import * as problemsList from './problemsList';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    problemsList: problemsList.IState
}

export const ActionCreators = {
    problemsList: problemsList.ActionCreators,
}

export const Reducers = combineReducers<IState>({
    problemsList: problemsList.Reducers,
});

export function* sagas() {
    yield all([
        fork(problemsList.sagas),
    ]);
}

